import {Component} from "@angular/core";
import {SnowridersService} from "./snowriders.service";

@Component({
  selector: "logo",
  templateUrl: "./logo.component.html",
})
export class LogoComponent {
  showLogo: boolean = false;

  constructor(private snowridersService: SnowridersService) {
    this.snowridersService.showLogo.subscribe((value) => {
      this.showLogo = value;
    });
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/logo.component.ts